import { Injectable } from '@angular/core';
import { AbstractNavigationService } from './abstract-navigation.service';
import { NavigableRecord, BaseNavigationQueryParams } from './navigable-record.interface';

@Injectable({ providedIn: 'root' })
export class SalesOfficeNavigationService extends AbstractNavigationService<NavigableRecord, BaseNavigationQueryParams> {
  protected override readonly basePath = ['master', 'configuration', 'sales-office'];
  protected override readonly navigationDescription = 'Ver en Oficinas de Venta';
}
